export default "__VITE_ASSET__Dgy3KL$q__"